// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__Epqd8","errorLogs":"EditorFooter_errorLogs__3iDH4"};